import { Box, Button } from "@material-ui/core"
import { KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons"
import { formatMoneyValue, formatNumber, ACCOUNT_GROUP_TYPE } from "../../../utils/financialHelper"
import { ContentCategory, ContentMonth, ContentTotal, ContentWrapper } from "./DRE.styles"

/* eslint-disable */
const DREColumnsContent = ({
  values = {},
  total = 0,
  name = "",
  paddingLeft = '1',
  canExpand = true,
  collapsed,
  setCollapsed,
  isPercent = false,
  backgroundColor,
}) => {

  const months = Object.keys(values)
  const realPaddingLeft = `${paddingLeft * 8}px`
  const cursor = canExpand ? 'pointer' : 'auto'
  const border = 'solid 1px #fff'

  return (
    <ContentWrapper
      onClick={() => canExpand ? setCollapsed(!collapsed) : null}
      style={{ cursor }}
    >

      {/* Category */}
      <ContentCategory
        style={{
          paddingLeft: realPaddingLeft,
          backgroundColor,
          borderRight: border,
          borderBottom: border,
        }}
      >
        {canExpand ?
          <Button style={{ minWidth: '15px', padding: 0, marginRight: '5px', marginLeft: '-10px' }}>
            {collapsed
              ? <KeyboardArrowRight />
              : <KeyboardArrowDown />
            }
          </Button>
          : <Box component='span' style={{ width: '15px', display: 'inline-block' }} />
        }
        {name}
      </ContentCategory>

      {/* Months */}
      {months.map((month) => (
        <ContentMonth key={month}
          style={{
            backgroundColor,
            borderRight: border,
            borderBottom: border,
          }}
        >
          {isPercent ? `${formatNumber(values[month])} %` : formatMoneyValue(values[month])}
        </ContentMonth>
      ))}

      {/* Total */}
      <ContentTotal
        style={{
          backgroundColor,
          borderBottom: border,
        }}
      >
        {isPercent ? `${formatNumber(total)} %` : formatMoneyValue(total)}
      </ContentTotal>

    </ContentWrapper>
  )
}

export default DREColumnsContent
